import { select } from "d3-selection";
import "./styles.scss";

export default class ZoomTool {
	/**
	 * Creates a new zoom tool for the google.maps.Map instance.
	 * @param map - {google.maps.Map} instance.
	 */
	constructor(map) {
		this._map = map;
		this.geometry = {
			x1: 0,
			y1: 0,
			x2: 0,
			y2: 0,
		};
	}

	pointToLatLng(point, projection) {
		let rate = 8000 / 2;

		let svgPoint = new window.google.maps.Point(point.x - rate, point.y - rate);
		let coords = projection.fromDivPixelToLatLng(svgPoint);
		let latlng = { lat: coords.lat(), lng: coords.lng() }
		console.log("point to lat lng", latlng)
		return latlng;
	}

	xyToLatLng(x, y, projection) {
		return this.pointToLatLng({ x: x, y: y }, projection);
	}

	/**
	 *
	 *  nw(x1, y1) +------------------+ ne(x2, y1)
	 *             |                  |
	 *             |                  |
	 *             |                  |
	 *             |                  |
	 *             |                  |
	 *             |                  |
	 *  sw(x1, y2) +------------------+ se(x2, y2)
	 * @param {*} geometry
	 * @param {*} projection
	 */
	getCardinalsFromGeometry(geometry, projection) {
		const g = this.normalizeGeometry(geometry);
		return {
			nw: this.xyToLatLng(g.x1, g.y1, projection),
			ne: this.xyToLatLng(g.x2, g.y1, projection),
			sw: this.xyToLatLng(g.x1, g.y2, projection),
			se: this.xyToLatLng(g.x2, g.y2, projection),
		};
	}

	/**
	 *
	 * (min(x1, x2), min(y1, y2)) +------------------+
	 *                            |                  |
	 *                            |                  |
	 *                            |                  |
	 *                            |                  |
	 *                            |                  |
	 *                            |                  |
	 *                            +------------------+ (max(x1, x2), max(y1, y2))
	 * @param {*} geometry
	 */
	normalizeGeometry(geometry) {
		const x1 = Math.min(geometry.x1, geometry.x2);
		const y1 = Math.min(geometry.y1, geometry.y2);
		const x2 = Math.max(geometry.x1, geometry.x2);
		const y2 = Math.max(geometry.y1, geometry.y2);

		return {
			x1: x1,
			y1: y1,
			x2: x2,
			y2: y2,
			width: x2 - x1,
			height: y2 - y1,
		};
	}

	stopZoomTool() {
		this._overlay && this._overlay.setMap(null);
	}

	startZoomTool() {
		this.stopZoomTool()
		const _zoomTool = this;

		this._overlay = new window.google.maps.OverlayView();
		console.log(this._overlay);
		this._overlay.setMap(this._map);

		this._overlay.onRemove = () => {
			this._svgOverlay.remove();
		};

		this._overlay.onAdd = () => {
			_zoomTool._projection = _zoomTool._overlay.getProjection();

			const omt = _zoomTool._overlay.getPanes().overlayMouseTarget;
			_zoomTool._svgOverlay = select(omt)
				.append("div")
				.attr("class", "zoom-points-0033")
				.append("svg")
				.attr("class", "zoom-svg-overlay");

			const mousemove = (ev) => {
				_zoomTool.geometry.x2 = ev.layerX;
				_zoomTool.geometry.y2 = ev.layerY;

				const g = _zoomTool.normalizeGeometry(_zoomTool.geometry);

				_zoomTool.rect.attr("x", g.x1).attr("y", g.y1).attr("width", g.width).attr("height", g.height);
			};

			const mousedown = (ev) => {
				_zoomTool._map.setOptions({ draggable: false });

				if (_zoomTool.rect) {
					_zoomTool.rect.remove();
				}

				_zoomTool.geometry.x1 = ev.layerX;
				_zoomTool.geometry.y1 = ev.layerY;

				_zoomTool.rect = _zoomTool._svgOverlay
					.append("rect")
					.attr("x", _zoomTool.geometry.x1)
					.attr("y", _zoomTool.geometry.y1);

				_zoomTool._svgOverlay.on("mousemove", mousemove);
			};

			const mouseup = (ev) => {
				// Enable drag
				_zoomTool._map.setOptions({ draggable: true });

				// Stop Zoom Tool
				_zoomTool.stopZoomTool(_zoomTool.map);

				// Remove events
				_zoomTool._svgOverlay.on("mousemove", null);

				// ########### Perform Zoom ###########
				const cardinals = _zoomTool.getCardinalsFromGeometry(_zoomTool.geometry, _zoomTool._projection)

				var latlngbounds = new window.google.maps.LatLngBounds(cardinals.sw, cardinals.ne);

				_zoomTool._map.fitBounds(latlngbounds, -100);
			};

			_zoomTool._svgOverlay.on("mousedown", mousedown);
			_zoomTool._svgOverlay.on("mouseup", mouseup);

		};
	}
}



// WEBPACK FOOTER //
// ./src/index.js